import React, { useEffect } from "react";
import { googleAnalyticsActions } from "../../utils/ga";
import HomeSectionComponent from "../../components/HomeSectionComponent";
import TopNavComponent from "../../components/TopNavComponent";
import MobileNavComponent from "../../components/MobileNavComponent";
import FooterComponent from "../../components/FooterComponent";
import "./styles.css";

export default function HomeScreen() {
  useEffect(() => {
    googleAnalyticsActions.initGoogleAnalytics();
  }, []);
  return (
    <>
      <MobileNavComponent />
      <div className="home">
        <header class="home-top-nav">
          <TopNavComponent />
        </header>
        <main className="home-main">
          <HomeSectionComponent />
        </main>
        <footer className="home-footer">
          <FooterComponent />
        </footer>
      </div>
    </>
  );
}
